import { connect } from "react-redux";
import PmCheckList from "./pmCheckList";
import { bindActionCreators } from "redux";
import {
  fetchGatesChecklist,
  fetchCategoryType,
  fetchSubCategoryType,
  fetchCategory,
  postPmData,
} from "services/redux/maintenance/pmList/action";

const mapStateToProps = (state) => ({
  pmListChecklist: state.pmListReducer.pmListChecklist,
  typeData: state.pmListReducer.typeData,
  subCategoryType: state.pmListReducer.subCategoryType,
  categoryType: state.pmListReducer.categoryType,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchGatesChecklist,
      fetchCategoryType,
      fetchSubCategoryType,
      fetchCategory,
      postPmData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PmCheckList);
